<app-generic-list
  id="riderRideHistoryList"
  [testingIdAccessor]="['id']"
  [shouldShowLoader]="shouldShowLoader"
  [dataItems]="trips"
  [columns]="columns"
  [pageSize]="pageSize"
  [pageIndex]="pageIndex"
  [paginationLength]="100000"
  [paginationEnabled]="true"
  (paginationChangeHandler)="handlePaginationChange($event)"
  (itemSelectedHandler)="handleTripSelected($event)"
  data-private
>
</app-generic-list>
